/**
 * @generated SignedSource<<03d2d071ccf23633eaa87a66d6cb2078>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModule_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarouselVariant_user" | "HpSharedBestsellingDesignsCarousel_user" | "HpSharedExcellentValuesCarouselVariant_user" | "HpSharedExcellentValuesCarousel_user" | "HpSharedMostSavedItemsCarouselVariant_user" | "HpSharedMostSavedItemsCarousel_user">;
  readonly " $fragmentType": "HpSharedLocationsModule_user";
};
export type HpSharedLocationsModule_user$key = {
  readonly " $data"?: HpSharedLocationsModule_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModule_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isCollectionsCapTestVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModule_user",
  "selections": [
    {
      "condition": "isCollectionsCapTestVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedMostSavedItemsCarousel_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedExcellentValuesCarousel_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedBestsellingDesignsCarousel_user"
        }
      ]
    },
    {
      "condition": "isCollectionsCapTestVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedMostSavedItemsCarouselVariant_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedExcellentValuesCarouselVariant_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedBestsellingDesignsCarouselVariant_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "acc7fb72255e5ae7886f54f07feb9408";

export default node;
